import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';

@Component({
  standalone: false,
  templateUrl: './dialog-direct-cancel-interstitial.component.html',
  styleUrls: ['./dialog-direct-cancel-interstitial.component.scss'],
})
export class DialogDirectCancelInterstitialComponent implements OnInit {
  directSub$ = this.directSubService.subscriptionStatus$;
  cancelling: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDirectCancelInterstitialComponent>,
    private directSubService: DirectSubscriptionService
  ) { }

  ngOnInit(): void { }

  cancel() {
    this.cancelling = true;

    this.directSubService.cancelDirect().subscribe(
      (res) => {
        this.cancelling = false;
        this.dialogRef.close();
      },
      (err) => {
        this.cancelling = false;
      }
    );
  }
}
